import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipTotalReceived = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                Quantia recebida no extrato e exibida <br/>
                após o repasse do provedor <br/>
                financeiro.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipTotalReceived;